import { all } from 'redux-saga/effects';

import { filterSagas } from '../filter';
import { reportSagas } from '../report';

import actionsThatTriggerFetches from './actionsThatTriggerFetches';
import fetchDataSaga from './fetchData';
import resetFiltersSagas from './resetFilters';
import runReportValidationSaga from './runReportValidation';

// Here we're combining all of the sagas into one
export default function* playersAndTeamsSaga() {
    yield all({
        ...filterSagas,
        ...reportSagas,
        ...actionsThatTriggerFetches,
        ...resetFiltersSagas,
        fetchData: fetchDataSaga(),
        runReportValidation: runReportValidationSaga(),
    });
}
